import type { Meta, StoryObj } from "@storybook/react";

import type { SecondarySectionHeaderProps } from "@/ui/core";
import { SecondarySectionHeader } from "@/ui/core";

const StoryMeta: Meta<SecondarySectionHeaderProps> = {
  title: "Core/Secondary Section Header",
  component: SecondarySectionHeader,
  argTypes: {
    buttonTitle: { control: "text" },
    onButtonPress: { action: "button pressed" },
    testID: { control: "text" },
    title: { control: "text" },
  },
  args: {
    buttonTitle: "Learn More",
    testID: "secondary-section-header",
    title: "Storybook",
  },
};

type Story = StoryObj<SecondarySectionHeaderProps>;

export const Primary: Story = {};
export default StoryMeta;
